import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import H6 from 'UIComponents/elements/headings/H6';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { track } from '../../common/eventTracking/tracker';
import { loadAndOpenSalesChat } from '../../utils/loadAndOpenSalesChat';
import { MODAL_TYPES } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  GET_A_CALL,
  MEETING,
  EMAIL
} = MODAL_TYPES;
const FooterWrapper = styled.div.withConfig({
  displayName: "AssignableModalBody__FooterWrapper",
  componentId: "jefsx0-0"
})(({
  theme
}) => ({
  textAlign: 'left',
  marginTop: theme.space['900']
}));
export const AssignableModalBody = ({
  handleIframeSizeChange,
  setCurrentModalView,
  showChatButton,
  upgradeData,
  onClose,
  repInfo
}) => {
  const handleClick = (communicationKey, trackingAction) => {
    track('communicationMethodsInteraction', Object.assign({
      action: trackingAction
    }, getUpgradeDataTrackingProperties(upgradeData), {
      repName: getRepName(repInfo)
    }));
    handleIframeSizeChange(communicationKey);
    setCurrentModalView(communicationKey);
  };
  const handleClickChat = () => {
    loadAndOpenSalesChat({
      upgradeData,
      isRetail: false,
      isAssignable: true
    });
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked chat with us'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      repName: getRepName(repInfo)
    }));
    onClose();
  };
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "assignable-modal-body",
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "stretch",
        justify: "center",
        children: [/*#__PURE__*/_jsxs(UISelectableButton, {
          "data-test-id": "communication-method-meeting",
          size: "large",
          onClick: () => handleClick(MEETING, 'clicked contact sales with meeting'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.meeting"
          }),
          children: [/*#__PURE__*/_jsx(UIBadge, {
            className: "m-bottom-2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.communicationMethods.recommended"
            })
          }), /*#__PURE__*/_jsx(UIIllustration, {
            name: "meetings-small",
            height: 75
          })]
        }), /*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "communication-method-call",
          size: "large",
          onClick: () => handleClick(GET_A_CALL, 'clicked contact sales with phone call'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.call"
          }),
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "calling-small",
            height: 75,
            className: "m-top-7"
          })
        }), /*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "communication-method-email",
          size: "large",
          onClick: () => handleClick(EMAIL, 'clicked send email'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.email"
          }),
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "successfully-connected-email",
            height: 75,
            className: "m-top-7"
          })
        }), showChatButton && /*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "communication-method-chat",
          size: "large",
          selected: false,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.chatWithUs"
          }),
          onClick: handleClickChat,
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "contacts-chat",
            height: 75,
            className: "m-top-7"
          })
        })]
      }), /*#__PURE__*/_jsxs(FooterWrapper, {
        children: [/*#__PURE__*/_jsx(H6, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.footer.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.footer.body"
          })
        })]
      })]
    })
  });
};